<template>

	<div>
		<ul>
			<li class="template-card" v-for="template in templates" :title="template.name">
				<div class="d-flex justify-content-between align-items-center mb-1">
					<strong :disabled="!template.is_published">{{ template.category }} / {{ template.name }}</strong>
					<div>
						<span class="btn btn-sm btn-outline-warning" @click="onEdit(template)" title="Category">E</span>
						<a class="btn btn-sm btn-outline-primary" :href="'/template/'+template.id" target="_blank" title="Category">V</a>
						<span class="btn btn-sm btn-outline-warning" @click="promptOrder(template)" title="order">O</span>
						<span class="btn btn-sm btn-outline-danger" @click="deleteTemplate(template)" title="delete">D</span>
						<span class="btn btn-sm btn-outline-primary" @click="autoThumbnail(template)" title="generate thumb">Img</span>
					</div>
				</div>
				<img v-if="template.thumbnail" :src="template.thumbnail">
			</li>
		</ul>

		<div class="p-3 d-flex justify-content-between align-items-center">
			<div>
				<input class="mr-1" type="text" v-model="screenshotSize">
				<label class="mr-1"><input type="checkbox" v-model="screenshotTrim"> trim</label>
			</div>

		</div>




		<div class="modal  modal-active" v-if="modalEdit">
			<div class="modal-dialog">
				<div class="modal-content">

					<div class="form-group">
						<label>Name</label>
						<input v-model="template.name" class="form-control" required>
					</div>
					<div class="form-group">
						<label>Category</label>
						<input v-model="template.category" class="form-control" required>
					</div>
					<div class="form-group">
						<label>Order</label>
						<input type="number" v-model="template.order" class="form-control" required>
					</div>
					<div class="form-group">
						<label>Published</label>
						<div>
							<label class="mr-3"><input type="radio" v-model="template.is_published" value="1" required> Yes</label>
							<label><input type="radio" v-model="template.is_published" value="0" required> No</label>
						</div>
					</div>
					<span class="btn btn-primary" @click="onSubmit">submit</span>
					<span class="btn btn-light" @click="modalEdit = false;">Close</span>
				</div>
			</div>
		</div>


		<div class="modal modal-center modal-active" v-if="modalOrder">
			<div class="modal-dialog">
				<div class="modal-content">
					<input type="number" min="0" v-model="order" class="form-control">
					<span class="btn btn-primary" @click="setOrder">submit</span>
					<span class="btn btn-light" @click="modalOrder = false;">Close</span>
				</div>
			</div>
		</div>


	</div>

</template>
<style scoped>

[disabled] { opacity: .3; }

ul { list-style:none; margin:0; padding:0; }
ul { display:flex; flex-wrap:wrap;}
ul li { width:300px; padding:15px; border-radius:5px; background:#fff; box-shadow:1px 1px 3px rgba(0,0,0,.2); margin:0 10px 10px; }
ul li img { max-width:100%; height:auto; display:block;}

.modal   { display:none; background:rgba(0,0,0,.5)}


.modal-active { display:block; }
.modal-active.modal-center   { display:flex; align-items:center; justify-content:center; }
.modal-dialog   {
	width:100%; width:calc(100% - 20px);
	max-width:600px;
	max-height:90vh;
	background-color:#fff; box-shadow:1px 1px 5px rgba(0,0,0,.8);
	position:relative;
}
.modal-close   { position:absolute; top:-0.5em; right:-0.5em; cursor:pointer; background:#fff; border-radius:50px; display:inline-block; width:1em; height:1em; text-align:center; font-size:20px; font-weight:bold; line-height:1; color:rgba(0,0,0,.5); }
.modal-title   { padding:20px; border-bottom:1px solid #ccc; }
.modal-content   { padding:20px;  }

</style>
<script>

	import componentFunctions from '@/mixin.components.js'
	import axios from 'axios';
	import Vue from 'vue';

	export default window.vmPage = {
		mixins:[componentFunctions],
		data() {
			return {
				templates:[],
				screenshotSize:'1280,1280',
				screenshotTrim:false,
				modalOrder:false,
				modalEdit:false,
				template_id:null,
				template:null,
				order:99,
			}
		},
		mounted(){
			this.getTemplates();

		},
		methods:{

			promptOrder(template){
				this.template_id =template.id;
				this.order =template.order;
				this.modalOrder = true;
			},
			setOrder(){
				axios({
					method: 'post',
					url: '/erp/reorder-template/'+this.template_id,
					data:{ order:this.order },
				}).then(()=>{
					this.getTemplates();
					this.modalOrder = false;
				});
			},



			onEdit(template){
				this.template = JSON.parse(JSON.stringify(template))
				this.modalEdit = true;
			},

			onSubmit(){
				var data = this.template;
				axios({
					method: 'post',
					url: '/erp/template/'+data.id,
					data:data,
				}).then(()=>{
					this.getTemplates();
					toastr('ok','','lightgreen');
					this.modalEdit = false;
				}).catch(res=>{
					toastr('falha','','red');
					console.error(res);
				});

			},


			deleteTemplate(template){
				if(!confirm('are you sure?')) return;
				axios({
					method: 'post',
					url: '/erp/delete-template/'+template.id,
				}).then(()=>{
					this.getTemplates();
					toastr('ok','','lightgreen');
				}).catch(res=>{
					toastr('falha','','red');
					console.error(res);
				});

			},

			getTemplates(){
		      axios({
		        url: '/erp/templateList',
		      }).then((res) => {
		        this.templates = res.data;
		      });
			},

			autoThumbnail(template){

				var params = [];
				params.push('size='+this.screenshotSize);
				if(this.screenshotTrim) params.push('trim=1');

				var url = '/api/template-screenshot/'+template.id+'?'+params.join('&');

				axios.get(url).then((response)=> {
					this.getTemplates();
					toastr('ok','','lightgreen');

				}).catch((error) =>  {
					console.error(error);
					if(error.response) alert(error.response.data);
				})
			},

		}

	}


</script>

